import { ButtonBase, DialogActions } from '@material-ui/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogComponent, UploaderComponent } from '../../../../Components';
import { DefaultImagesEnum, UploaderThemesEnum } from '../../../../Enums';
import { showError, showSuccess } from '../../../../Helper';
import { ImportFile } from '../../../../Services/File';

function ImportDevelopersDialog({
  isOpen,
  translationPath,
  parentTranslationPath,
  setIsImportDialogOpen,
  getDevelopersData,
}) {
  const { t } = useTranslation(parentTranslationPath);
  const [file, setFile] = useState(null);

  function onCloseClicked() {
    setFile(null);
    setIsImportDialogOpen(false);
  }

  async function onFileUpload(files) {
    if (files.length === 0) return;
    setFile(files[0]);
  }

  async function onImportClicked() {
    const res = await ImportFile({
      fileId: file.uuid,
      importProcceseType: 10,
    });

    if (!(res && res.status && res.status !== 200)) {
      await getDevelopersData();
      showSuccess(t(`${translationPath}fields-approve-notifications`));
      onCloseClicked();
    } else {
      showError(t(`fields-reject-notifications`));
    }
  }

  return (
    <>
      <DialogComponent
        isOpen={isOpen}
        maxWidth='md'
        titleText={t(`import-developers`)}
        dialogContent={
          <>
            <div>
              <div>
                <UploaderComponent
                  idRef='contactsImportRef'
                  accept='.xls,.xlsx,.xlsm'
                  uploadedChanged={(files) => {
                    onFileUpload(files);
                  }}
                  allFilesChanged={(files) => {}}
                  defaultImage={DefaultImagesEnum.individual.key}
                  uploaderTheme={UploaderThemesEnum.box.key}
                />
              </div>

              <div className='mt-4'>
                <DialogActions className='d-flex justify-content-between'>
                  <div
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <div>
                      <a
                        href='/files/DeveloperContactCustomTemplate.xlsx'
                        download='Developer Contact Template'
                        className='MuiButtonBase-root MuiButton-root MuiButton-text btns c-danger'
                      >
                        <span className='MuiButton-label'>
                          <span className='mx-2'>{t(`download`)}</span>
                        </span>
                      </a>
                    </div>
                    <div>
                      <ButtonBase
                        className='MuiButtonBase-root btns bg-cancel'
                        onClick={() => {
                          onCloseClicked();
                        }}
                        disabled={false}
                      >
                        <span>{t('cancel')}</span>
                      </ButtonBase>

                      <ButtonBase
                        className='MuiButtonBase-root btns theme-solid'
                        onClick={() => {
                          onImportClicked();
                        }}
                        disabled={false}
                      >
                        <span>{t('import')}</span>
                      </ButtonBase>
                    </div>
                  </div>
                </DialogActions>
              </div>
            </div>
          </>
        }
        translationPath={translationPath}
        parentTranslationPath={parentTranslationPath}
      />
    </>
  );
}

export default ImportDevelopersDialog;
